import { useEffect, useContext } from 'react';

import { useHistory, Route } from 'react-router-dom';

import { SessionContext } from '../../../context/session.context';
import { has } from '../../../services/summarize.service';

export const ProtectedRouteComponent = ({ path, component, key, exact, policy }) => {

  const { logged } = useContext(SessionContext);

  const history = useHistory();

  const authorized = () => {
    return has(policy);
  }

  const redirect = () => {
    history.push('/main');
  }

  useEffect(() => {
    if (!logged) {
      redirect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policy]);

  return logged && authorized() ? (
    <Route path={path} exact={exact} key={key} component={component} />
  ) : (
    <div onLoad={redirect()}></div>
  );
}